// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-sidebar-SettingsBox-module__parent {
    margin-top: 15px;
    padding: 15px 5px 10px 5px;
    border-top: 1px lightgray solid;
    border-bottom: 1px lightgray solid;
}

.src-sidebar-SettingsBox-module__settingsTable {
    display: flex;
    flex-direction: column;
    align-items: start;
    gap: 0;
    margin: 0.2rem 0.5rem 1.5rem 0;
}

.src-sidebar-SettingsBox-module__settingsTable svg {
    scale: 0.7;
    margin-left: calc(-8px); /* scaling svg creates white space around it */
}

.src-sidebar-SettingsBox-module__settingsToggle {
    cursor: pointer;
    display: grid;
    grid-template-columns: 50px auto;
    align-content: flex-start;
    align-items: center;
}

.src-sidebar-SettingsBox-module__groupProfileOptionsHeader {
    font-weight: bold;
}

.src-sidebar-SettingsBox-module__groupProfileOptions div {
    padding: 4px 20px;
}

.src-sidebar-SettingsBox-module__groupProfileOptions label,
input {
    cursor: pointer;
}

.src-sidebar-SettingsBox-module__groupProfileOptions label {
    margin-left: 10px;
}

.src-sidebar-SettingsBox-module__toggleButton {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 2rem;
}

.src-sidebar-SettingsBox-module__settingsCheckboxes {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    flex-wrap: wrap;
    height: 2rem;
}

.src-sidebar-SettingsBox-module__settingsCheckbox label {
    padding-left: 3px;
}

.src-sidebar-SettingsBox-module__settingsCheckbox:hover label,
.src-sidebar-SettingsBox-module__settingsCheckbox:hover input {
    cursor: pointer;
}

.src-sidebar-SettingsBox-module__infoLine {
    padding: 10px 2px 0 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.src-sidebar-SettingsBox-module__infoLine a {
    color: gray;
    text-decoration: none;
}

.src-sidebar-SettingsBox-module__infoLine a:hover {
    color: black;
}

.src-sidebar-SettingsBox-module__title {
    font-weight: bold;
}

.src-sidebar-SettingsBox-module__title,
.src-sidebar-SettingsBox-module__infoLine,
.src-sidebar-SettingsBox-module__settingsTable,
.src-sidebar-SettingsBox-module__groupProfileOptionsHeader {
    font-size: 14px;
    color: gray;
}
`, "",{"version":3,"sources":["webpack://./src/sidebar/SettingsBox.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,+BAA+B;IAC/B,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,MAAM;IACN,8BAA8B;AAClC;;AAEA;IACI,UAAU;IACV,uBAAuB,EAAE,8CAA8C;AAC3E;;AAEA;IACI,eAAe;IACf,aAAa;IACb,gCAAgC;IAChC,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;;;IAII,eAAe;IACf,WAAW;AACf","sourcesContent":[".parent {\n    margin-top: 15px;\n    padding: 15px 5px 10px 5px;\n    border-top: 1px lightgray solid;\n    border-bottom: 1px lightgray solid;\n}\n\n.settingsTable {\n    display: flex;\n    flex-direction: column;\n    align-items: start;\n    gap: 0;\n    margin: 0.2rem 0.5rem 1.5rem 0;\n}\n\n.settingsTable svg {\n    scale: 0.7;\n    margin-left: calc(-8px); /* scaling svg creates white space around it */\n}\n\n.settingsToggle {\n    cursor: pointer;\n    display: grid;\n    grid-template-columns: 50px auto;\n    align-content: flex-start;\n    align-items: center;\n}\n\n.groupProfileOptionsHeader {\n    font-weight: bold;\n}\n\n.groupProfileOptions div {\n    padding: 4px 20px;\n}\n\n.groupProfileOptions label,\ninput {\n    cursor: pointer;\n}\n\n.groupProfileOptions label {\n    margin-left: 10px;\n}\n\n.toggleButton {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 2rem;\n}\n\n.settingsCheckboxes {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    flex-wrap: wrap;\n    height: 2rem;\n}\n\n.settingsCheckbox label {\n    padding-left: 3px;\n}\n\n.settingsCheckbox:hover label,\n.settingsCheckbox:hover input {\n    cursor: pointer;\n}\n\n.infoLine {\n    padding: 10px 2px 0 0;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n}\n\n.infoLine a {\n    color: gray;\n    text-decoration: none;\n}\n\n.infoLine a:hover {\n    color: black;\n}\n\n.title {\n    font-weight: bold;\n}\n\n.title,\n.infoLine,\n.settingsTable,\n.groupProfileOptionsHeader {\n    font-size: 14px;\n    color: gray;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"parent": `src-sidebar-SettingsBox-module__parent`,
	"settingsTable": `src-sidebar-SettingsBox-module__settingsTable`,
	"settingsToggle": `src-sidebar-SettingsBox-module__settingsToggle`,
	"groupProfileOptionsHeader": `src-sidebar-SettingsBox-module__groupProfileOptionsHeader`,
	"groupProfileOptions": `src-sidebar-SettingsBox-module__groupProfileOptions`,
	"toggleButton": `src-sidebar-SettingsBox-module__toggleButton`,
	"settingsCheckboxes": `src-sidebar-SettingsBox-module__settingsCheckboxes`,
	"settingsCheckbox": `src-sidebar-SettingsBox-module__settingsCheckbox`,
	"infoLine": `src-sidebar-SettingsBox-module__infoLine`,
	"title": `src-sidebar-SettingsBox-module__title`
};
export default ___CSS_LOADER_EXPORT___;
